import {
  UUID_REGEX,
  SPECIFIC_SUGGESTION_REGEX,
  BLOCKQUOTE_REGEX
} from 'core/constants/regex';
import { CandidateProfileLinkData } from './parseMessageWithCandidatesAndChips';

type ConvertMessageToPlainTextProps = {
  messageBody: string;
  candidateProfiles: CandidateProfileLinkData[];
};

/**
 * Converts a message body with UUIDs and tags to plain text for copying.
 * - Replaces UUIDs with candidate names
 * - Extracts text content from <specific_suggestion> and <blockquote> tags
 */
export const convertMessageToPlainText = ({
  messageBody,
  candidateProfiles
}: ConvertMessageToPlainTextProps): string => {
  // Create a lookup object for fast candidate access
  const candidateLookup: Record<string, CandidateProfileLinkData> = {};
  candidateProfiles.forEach((candidate) => {
    candidateLookup[candidate.id] = candidate;
  });

  let result = messageBody;

  // First, replace all <specific_suggestion> tags with just their content
  result = result.replace(SPECIFIC_SUGGESTION_REGEX, '$1');

  // And blockquotes, so a copied reply does not carry the raw tags
  result = result.replace(BLOCKQUOTE_REGEX, (_match, content) =>
    String(content ?? '').trim()
  );

  // Then, replace all UUIDs with candidate names
  result = result.replace(new RegExp(UUID_REGEX.source, 'g'), (match) => {
    // Strip angle brackets from UUID: <uuid> -> uuid
    const uuid = match.replace(/[<>]/g, '');
    const candidate = candidateLookup[uuid];

    if (candidate && candidate.full_name) {
      return candidate.full_name;
    }

    // If candidate not found, return original match
    return match;
  });

  return result;
};
